import { __extends } from 'tslib';
import classNames from 'classnames';
import React__default, { PureComponent } from 'react';
import styles from './Shadows.module.scss.js';

var Shadows = (function (_super) {
    __extends(Shadows, _super);
    function Shadows() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showShadowTop: false,
            showShadowBottom: false,
            shadowPositionLeft: 0,
            shadowWidth: 0,
            prevScrollPosition: null,
        };
        _this.updateShadows = function () {
            var scrollPosition = _this.appContainer ? _this.appContainer.scrollTop : 0;
            var scrollHeight = _this.appContainer ? _this.appContainer.scrollHeight - _this.appContainer.clientHeight : 0;
            var state = {
                showShadowTop: scrollPosition > 0,
                showShadowBottom: scrollPosition < scrollHeight,
                shadowPositionLeft: _this._section ? _this._section.getBoundingClientRect().left : 0,
                shadowWidth: _this._section ? _this._section.getBoundingClientRect().width : 0,
                prevScrollPosition: null,
            };
            if (scrollPosition > 0) {
                state.prevScrollPosition = scrollPosition;
            }
            _this.setState(state);
        };
        return _this;
    }
    Shadows.prototype.componentDidMount = function () {
        var id = this.props.appContainerId ? this.props.appContainerId : 'app';
        this.appContainer = document.getElementById(id);
        if (this.appContainer) {
            this.appContainer.addEventListener('scroll', this.updateShadows);
        }
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', this.updateShadows);
        this.updateShadows();
    };
    Shadows.prototype.componentDidUpdate = function () {
        this.updateShadows();
    };
    Shadows.prototype.componentWillUnmount = function () {
        if (this.appContainer) {
            this.appContainer.removeEventListener('scroll', this.updateShadows);
        }
        window === null || window === void 0 ? void 0 : window.removeEventListener('resize', this.updateShadows);
    };
    Shadows.prototype.render = function () {
        var _this = this;
        var _a;
        var bottomStyle = {
            left: this.state.shadowPositionLeft,
            width: this.state.shadowWidth,
        };
        var topStyle = {
            left: this.state.shadowPositionLeft,
            width: this.state.shadowWidth,
        };
        return (React__default.createElement("section", { className: classNames(styles.section, (_a = this.props) === null || _a === void 0 ? void 0 : _a.className), ref: function (c) {
                if (c) {
                    _this._section = c;
                }
            } },
            React__default.createElement("div", { className: styles.shadowTop + " " + (this.state.showShadowTop ? styles.isVisible : ''), style: topStyle }),
            this.props.children,
            React__default.createElement("div", { className: styles.shadowBottom + " " + (this.state.showShadowBottom ? styles.isVisible : ''), style: bottomStyle })));
    };
    return Shadows;
}(PureComponent));

export { Shadows as default };
//# sourceMappingURL=Shadows.js.map
